import React from "react";
import i18next from "i18next";
import PropTypes from "prop-types";

const GreenClubTag = ({ color }) => {
    return (
        <div className={`green-club__tag ${color}`}>
            <p>{i18next.t("productDetails.greenClub.tag")}</p>
        </div>
    );
};

GreenClubTag.propTypes = {
    color: PropTypes.string,
};

export default GreenClubTag;
